<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <span class="text">***</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component', 'components', 'value'],
  name: 'PasswordReadOnly'
}
</script>
